




























import { defineComponent } from '@vue/composition-api'
import { useCreateLeadForm } from '@/composables/useCreateLeadForm'

export default defineComponent({
    name: 'CreateLeadVerticalStep1',
    setup() {
        const {
            state,
            steps,
        } = useCreateLeadForm()

        return {
            state,
            steps,
        }
    },
})
